import React, { forwardRef } from "react";

const base =
  "w-full rounded-xl bg-white/[0.07] border text-white placeholder-white/40 " +
  "focus:outline-none focus:ring-2 focus:ring-primary/30 transition-colors " +
  "disabled:opacity-60";

// Text input on the dark brand surface. `ltr` for emails, codes and numbers
// inside the Arabic layout.
export const Input = forwardRef(
  ({ invalid = false, ltr = false, size = "md", className = "", ...rest }, ref) => (
    <input
      ref={ref}
      dir={ltr ? "ltr" : undefined}
      aria-invalid={invalid || undefined}
      className={[
        base,
        size === "lg" ? "h-14 px-5 text-xl" : "h-12 px-4 text-base",
        invalid
          ? "border-danger focus:border-danger"
          : "border-white/15 hover:border-white/25 focus:border-primary",
        className,
      ].join(" ")}
      {...rest}
    />
  )
);

export const Textarea = forwardRef(
  ({ invalid = false, className = "", ...rest }, ref) => (
    <textarea
      ref={ref}
      aria-invalid={invalid || undefined}
      className={[
        base,
        "px-4 py-3 text-base min-h-[96px]",
        invalid
          ? "border-danger"
          : "border-white/15 hover:border-white/25 focus:border-primary",
        className,
      ].join(" ")}
      {...rest}
    />
  )
);

// Label + control + hint/error, stacked.
export const Field = ({ label, htmlFor, hint, error, children, className = "" }) => (
  <div className={`space-y-1.5 ${className}`}>
    {label && (
      <label htmlFor={htmlFor} className="block text-sm font-semibold text-white/90">
        {label}
      </label>
    )}
    {children}
    {error ? (
      <p role="alert" className="text-sm font-medium text-danger">
        {error}
      </p>
    ) : hint ? (
      <p className="text-xs text-white/55 leading-relaxed">{hint}</p>
    ) : null}
  </div>
);

export default Field;
